(function ($) {
  Drupal.behaviors.styleguideV1 = {
    attach: function (context) {
      const $template = $('.js-styleguide-v1', context);
      const $toggleCode = $('.js-styleguide-trigger-code', $template);
      const $toggleNav = $('.js-styleguide-trigger-nav', $template);
      const $toggleCodePane = $('.js-styleguide__component-code', $template);
      const $navList = $('.js-styleguide__nav-list', $template);
      const navText = $template.find('[data-navlabel]', $template);

      if ($toggleCodePane.length) {
        $template.addClass('code-hidden');
      }
      if ($navList.length) {
        $template.addClass('nav-hidden');
      }
      // Generate nav items if we have populated templates.
      if (navText.length) {
        const mappedItems = navText.map(function () {
          const $this = $(this);
          const item = document.createElement('li');
          const navAnchor = document.createElement('a');

          navAnchor.setAttribute('href', `#${$this.attr('id')}`);
          navAnchor.innerText = $this.data('navlabel');

          item.appendChild(navAnchor);

          return item;
        });

        $navList.append(mappedItems);
      }

      $toggleCode.once().on('click', function () {
        $template.toggleClass('code-hidden');
      });

      $toggleNav.once().on('click', function () {
        $template.toggleClass('nav-hidden');
      });
    }
  };
})(jQuery);
